import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';

@jsonObject
export class AdminCosmeticFileRequest {
  @jsonMember(String)
  public readonly id!: Guid;

  public constructor(
    private readonly data: {
      id: Guid;
    },
  ) {
    this.id = data.id;
  }
}
